import React from 'react';
import 'Components/Modals/PaymentModal/index.css';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import PropTypes from 'prop-types';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBox, FDDeleteButton, FDPrimaryActionIconButton, FDStack,
} from '@facet-wealth/design';
import segmentEvents from 'EventTracking/consts/segmentEvents';
import { testAttr, dataAttrs } from 'Helpers/Testing';
import { useLeadPropsContext } from 'Context/LeadPropsContext';

const LeadPromo = ({ index, loading, setLoading }) => {
  const {
    resource, onDelete, onRemove, onSubmit, saving,
  } = useMetaLayoutContext();
  const { rootNodeProps, logEvent } = useEventTrackingLogEvent({ nodeName: 'lead-promos' });
  const leadProps = useLeadPropsContext();

  return (
    <div {...rootNodeProps}>
      <FDBox paddingY={0.5}>
        <FDStack justifyContent="space-between" alignItems="center" spacing={1}>
          <MetaControlField attr="name" />
          <MetaControlField attr="description" />
          <MetaControlField attr="code" {...dataAttrs('promo code input')} />
          <FDStack justifyContent="flex-end" alignItems="center" spacing={1}>
            <MetaFormFields resource={resource} />
            {!resource.id() && <FDPrimaryActionIconButton
              icon="check"
              loading={saving}
              disabled={loading}
              onClick={async () => {
                setLoading(true);
                try {
                  await onSubmit();
                } catch { /* nothing special */ }
                setLoading(false);
                logEvent(segmentEvents.leadTriedAddingPromo, leadProps);
              }}
              {...dataAttrs('submit promo code')}
            />}
            <FDDeleteButton
              size="sm"
              loading={saving}
              disabled={loading}
              onClick={async () => {
                if (resource.id()) {
                  setLoading(true);
                  try {
                    await onDelete();
                  } catch { /* nothing special */ }
                  setLoading(false);
                  logEvent(segmentEvents.leadTriedRemovingPromo, leadProps);
                } else {
                  onRemove();
                }
              }}
              {...dataAttrs('delete promo code', {
                [testAttr.dataIndex]: index,
                [testAttr.dataValue]: resource.attr('name'),
              })}
            />
          </FDStack>
        </FDStack>
      </FDBox>
    </div>
  );
};

LeadPromo.defaultProps = {
  index: undefined,
};

LeadPromo.propTypes = {
  index: PropTypes.number,
  loading: PropTypes.bool.isRequired,
  setLoading: PropTypes.func.isRequired,
};

export default LeadPromo;
